import 'babel-polyfill';
import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import axios from 'axios';
import Vuex from 'vuex';
// import echarts from 'echarts';
import Cookies from 'js-cookie';
// import clipboard from 'clipboard';
// import html2canvas from 'html2canvas';
// import rasterizehtml from 'rasterizehtml';


// WEBPACK FOOTER //
// ./src/vendors.js